import { loadStripe } from "@stripe/stripe-js/pure";
import { proxy } from "valtio/vanilla";

export type StripeStore = {
  stripeInstance?: ReturnType<typeof loadStripe>;
};

export const stripeStore = proxy<StripeStore>({});
